import { Link } from 'react-router-dom';
import Reveal from './Reveal';
import Arrow from './Arrow';
import DeliveryDiagram from './DeliveryDiagram';
import DiagramMotion from './DiagramMotion';

export default function EngagementSection() {
  return <section className="approach-section section-shell" aria-labelledby="approach-heading">
    <Reveal><div className="approach-layout">
      <div className="approach-copy">
        <p className="section-label">FRiCTONの支援</p>
        <h2 id="approach-heading">AIの相談から、<br />動き続ける仕組みまで。</h2>
        <p className="approach-lead">業務を知り、必要なものをつくり、現場で育てる。自社サービスの開発で培った知見を、お客様の事業につなげます。</p>
        <dl className="approach-steps">
          <div><dt>相談・設計</dt><dd>課題とデータを整理し、取り組む順番を決める。</dd></div>
          <div><dt>開発・実装</dt><dd>AIと業務システムを、使える形につなぐ。</dd></div>
          <div><dt>運用・改善</dt><dd>日々の利用を支え、次の改善につなげる。</dd></div>
        </dl>
        <div className="approach-links"><Link to="/service" className="solid-link">事業内容を見る <Arrow /></Link><Link to="/company" className="text-link">会社について <Arrow /></Link></div>
      </div>
      <DiagramMotion><DeliveryDiagram /></DiagramMotion>
    </div></Reveal>
  </section>;
}
